import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
import NavigationIcon from "@material-ui/icons/Navigation";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));

export default function FloatingActionButtons() {
  const classes = useStyles();

  return (
    <div
      className={classes.root}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
      }}
    >
      <Fab
        variant='extended'
        style={{
          backgroundColor: "black",
        }}
      >
        <a
          href='#top'
          style={{
            textDecoration: "none",
            fontWeight: 700,
            fontSize: "1.75rem",
            alignContent: "flex_end",
            color: "white",
          }}
        >
          <NavigationIcon className={classes.extendedIcon} />
          Navigate
        </a>
      </Fab>
    </div>
  );
}
